export default "__VITE_ASSET__D_pEiIam__"